module.exports = __webpack_public_path__ + "img/homeLogo.cd9f4885.png";